export default __webpack_public_path__ + "static/novo-banner-1024-1c8fe59aab3b291894804b9454f6f436.png";